import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Label, Tab, Tabs } from '@cancercentrum/rcc-bootstrap';
import uniqueId from 'lodash/uniqueId';
import { useUncontrolled } from 'uncontrollable';
import { IncaRowContext } from '../IncaRowContext';
import { useI18n } from '../../i18n';
import { useClearable } from '../../hooks/useClearable';
const defaultRenderTitle = ({ row })=>`${row.$rcc.tableName} ${row.getId()}`;
const defaultIsCustomTab = (id)=>id.toString().indexOf('@') === 0;
export const SubTableTabs = /*#__PURE__*/ memo(function SubTableTabs(props) {
    const { className = 'subtable-tabs', emptyContent, filterFn, sortFn, subTable, // value,
    bsStyle, animation = false, renderRow, renderTitle = defaultRenderTitle, renderPrepend, renderAppend, isCustomTab = defaultIsCustomTab, renderIfEmpty, onTabClick } = props;
    const { t } = useI18n();
    const generatedId = useMemo(()=>uniqueId('Tabs_'), []);
    const id = props.id || generatedId;
    const { value, onChange } = useUncontrolled(props, {
        value: 'onChange'
    });
    useClearable((row)=>row.clearSubTable(props.subTable.$rcc.tableName));
    const onSelect = (eventKey)=>{
        const e = {
            cancel: false,
            eventKey
        };
        onTabClick && onTabClick(e);
        if (!e.cancel) {
            onChange?.(eventKey);
        }
    };
    const emptyMsg = emptyContent || t('subtable.empty');
    let rows = subTable.getRows();
    if (filterFn) {
        rows = rows.filter(filterFn);
    }
    if (sortFn) {
        rows = rows.sort(sortFn);
    }
    if (!renderIfEmpty && rows.isEmpty()) {
        return /*#__PURE__*/ _jsx("div", {
            className: className,
            children: emptyMsg
        });
    }
    const rowTemplates = rows.reduce((reduction, row)=>{
        const rowId = row.getId();
        const errors = row.getErrors();
        const errorsCount = errors.filter((x)=>x.$errors.some((y)=>y.isFatal)).length;
        const warningsCount = errors.filter((x)=>x.$errors.some((y)=>!y.isFatal)).length;
        let rowTitle = renderTitle({
            row
        });
        if (errorsCount > 0 || warningsCount > 0) {
            const style = errorsCount > 0 ? 'danger' : warningsCount > 0 ? 'warning' : undefined;
            rowTitle = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-error-wrapper",
                        children: /*#__PURE__*/ _jsx(Label, {
                            bsStyle: style,
                            children: errorsCount + warningsCount
                        })
                    }),
                    rowTitle
                ]
            });
        }
        reduction.push(/*#__PURE__*/ _jsx(Tab, {
            title: rowTitle,
            eventKey: rowId.toString(),
            children: /*#__PURE__*/ _jsx(IncaRowContext, {
                tableName: row.$rcc.tableName,
                rowId: row.getId(),
                children: ({ dataActions })=>renderRow({
                        row,
                        dataActions
                    })
            })
        }, rowId.toString()));
        return reduction;
    }, []);
    let activeTabId = value;
    if (!rows.isEmpty() && (!activeTabId || !isCustomTab(activeTabId) && rows.every((x)=>x.getId().toString() !== value))) {
        activeTabId = rows.first().getId().toString();
    }
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsxs(Tabs, {
            id: id,
            activeKey: activeTabId ? activeTabId.toString() : null,
            onSelect: onSelect,
            animation: animation,
            bsStyle: bsStyle,
            children: [
                renderPrepend && renderPrepend(),
                rowTemplates,
                renderAppend && renderAppend()
            ]
        })
    });
});
